import { debounce } from "../inc/helpers";

export default class CardsText {
    _contParent = null;
    _container = null;
    _breakpoint = null;
    _slides = [];
    _pagination = null;
    _bullets = [];
    _offsets = [];
    _idxCurrent = 0;
    _start = 0;
    _leftPrev = 0;
    _onResize = null;

    constructor() {
        for (const [key, value] of Object.entries(arguments[0]))
            this[`_${key}`] = value;       
        
        this._setup();
        this._init();        

        this._onResize = () => this._setup() 
        window.addEventListener("resize", debounce(this._onResize));
    }

    _setup() {
        this._start = (this._contParent.offsetWidth / 2);
        this._leftPrev = 0;
        this._contParent.scrollLeft = 0;
        this._idxCurrent = 0;        
        this._bullets = Array.from(this._pagination.querySelectorAll(".cards-text-pagination-bullet"));
        this._offsets = Array.from(this._slides).map((s, i) => (s.offsetWidth / 2) * (i + 1));
        this._setBulletActive();
    }
 
    _init() {
        this._contParent.addEventListener("scroll", (e) => {
            const left = this._contParent.scrollLeft + this._start;
            const toRight = left > this._leftPrev;    
            
            if (this._contParent.scrollLeft === 0) {
                this._idxCurrent = 0;
            
            } else if (toRight && this._leftPrev >= this._offsets[this._idxCurrent + 1]) {
                this._idxCurrent = 
                    this._idxCurrent + 1 > this._offsets.length - 1
                        ? this._idxCurrent
                        : this._idxCurrent + 1;

            } else if (!toRight && this._leftPrev <= this._offsets[this._idxCurrent]) {
                this._idxCurrent = 
                    this._idxCurrent - 1 > 0
                        ? this._idxCurrent - 1
                        : 0;            
            } 

            this._setBulletActive(this._idxCurrent);            
            this._leftPrev = left;
        });
    }

    _setBulletActive(i = 0) {
        const prev = this._bullets.find(b => b.classList.contains("is-active"));
        prev?.classList.remove("is-active");
        this._bullets?.[i]?.classList.add("is-active");
    }
}